export const getRootPath = (path: string, fallback?: string): string => {
    if (path.includes('/')) return `/${path.split('/')[1]}`;
    else if (fallback) return fallback;
    return '/';
};
